import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PageNotFound = () => {
  return (
    <div className="container text-center d-flex align-items-center justify-content-center" style={{ height: "86vh" }}>
      <div className="card shadow p-4" style={{ maxWidth: "500px" }}>
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h2 className="mb-3">Page Not Found</h2>
        <p>
          Sorry, The page you are trying to access does not exist or is not accessible.
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
